import getBuyerAPIDomain from "./getBuyerAPIDomain";
import getEnvironment from "./getEnvironment";

export const REL_MAPPER = {
  printSelectedVehicles: {
    contentType: "application/pdf",
  },
  exportSelectedVehicles: {
    contentType:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  },
  printAll: {
    contentType: "application/pdf",
  },
  exportAll: {
    contentType:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  },
  trackedVehiclesWithGuidePricing: {
    contentType: "application/pdf",
  },
};

const fetchFile = async (
  url: string,
  rel: string,
  authToken: string,
  isToUseAuthZero: boolean
) => {
  let headers: HeadersInit = {
    "Content-Type": REL_MAPPER[rel].contentType,
  };

  if (isToUseAuthZero) {
    headers = {
      ...headers,
      Authorization: `Bearer ${authToken}`,
    };
  } else {
    headers = { ...headers, Authorization: `Bearer ${process.env.TOKEN}` };
  }
  let endUrl: string;
  if (getEnvironment() === "localhost") {
    endUrl = url;
  } else {
    const buyerAPIDomain = getBuyerAPIDomain(isToUseAuthZero);
    const BEResponseURL = new URL(url);
    const pdfUrl = new URL(`${buyerAPIDomain.origin}`, buyerAPIDomain);
    pdfUrl.pathname = isToUseAuthZero
      ? BEResponseURL.pathname
      : `/search${BEResponseURL.pathname}`;
    pdfUrl.search = BEResponseURL.search;
    endUrl = pdfUrl.href;
  }

  const response = await fetch(endUrl, {
    method: "GET",
    headers,
    redirect: "follow",
  });

  if (response.ok) {
    const blob = await response.blob();
    var _url = window.URL.createObjectURL(blob);
    window.open(_url, "_blank").focus();
  }

  return response;
};

export default fetchFile;
